/**
 *
 * @Copyright 2024 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */
import React, { FunctionComponent } from 'react';
import { HelpAndSupportContext, HelpAndSupportContextProvider } from './HelpAndSupportContext';
import { useCornerstoneApi } from '../../api';
import { submitTicketUrl } from '../../services/help';
import { NewTicketResponse } from '../../types/help';
import { ErrorResponse } from '../../types/errors';

interface OwnProps {
    children: React.ReactNode;
}

type Props = OwnProps;

export const HelpAndSupportController: FunctionComponent<Props> = (props: Props) => {
    const {
        children,
    } = props;

    const CornerstoneApiInstance = useCornerstoneApi();

    const submitTicket: HelpAndSupportContext['submitTicket'] = async (payload, options) => {
        try {
            const formData = new FormData();
            formData.append('problem', payload.problem);
            formData.append('contextUrl', String(payload.contextUrl));
            if (payload.files && payload.files.length > 0) {
                for (let i = 0; i < payload.files?.length; i++) {
                    const currFile = payload.files[i];
                    formData.append('files', currFile);
                }
            }

            const { data } = await CornerstoneApiInstance.post<NewTicketResponse>(
                submitTicketUrl(),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: options?.onUploadProgress,
                },
            );
            return [data, null];
        } catch (error) {
            return [null, error as ErrorResponse];
        }
    };

    return (
        <HelpAndSupportContextProvider value={{
            submitTicket,
        }}
        >
            {children}
        </HelpAndSupportContextProvider>
    );
};
